var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroesseKreis02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Groesse-Kreis-02__Icn/40px/Groesse-Kreis-02",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Groesse-Kreis-02__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Groesse-Kreis-02__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,14 C23.3137085,14 26,16.6862915 26,20 C26,23.3137085 23.3137085,26 20,26 C16.6862915,26 14,23.3137085 14,20 C14,16.6862915 16.6862915,14 20,14 Z M20,16 C17.790861,16 16,17.790861 16,20 C16,22.209139 17.790861,24 20,24 C22.209139,24 24,22.209139 24,20 C24,17.790861 22.209139,16 20,16 Z",
    id: ".._.._src_svg_Icn_40px_Groesse-Kreis-02__Oval-Copy"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroesseKreis02);
export default __webpack_public_path__ + "static/media/Groesse-Kreis-02.7ea93585b5c2854e8732c17f4427dd9e.svg";
export { ForwardRef as ReactComponent };